import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../helpers/AuthContext';
import { toast } from 'react-toastify';

function Navbar() {
  const { authState, handleLogout } = useContext(AuthContext);
  const [nomprenom, setNomprenom] = useState('');
  const navigate = useNavigate();

  /*   if (!authState) {
    navigate('/login');
  } */

  const handleChange = (event) => {
    const value = event.target.value;
    setNomprenom(value);

    if (value) {
      const token = localStorage.getItem('accessToken');

      navigate(`/personnel?nomprenom=${encodeURIComponent(value)}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } else {
      navigate('/personnel');
    }
  };

  const logout = (e) => {
    e.preventDefault();
    handleLogout();
    navigate('/');
  };

  return (
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top ">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <a class="nav-link" href="/">
              <i className="fa fa-home"></i>
            </a>
          </li>
          {/*           <li class="nav-item active">
            <a class="nav-link" href="/dcca">
              DCCA <span class="sr-only"></span>
            </a>
          </li> */}

          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle active" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              OPTIONS
            </a>
            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
              <div>
                <a className="dropdown-item " href="/createpersonnel">
                  <i className="fa fa-address-card fa-lg mr-3" aria-hidden="true"></i>
                  Nouveau Personnel
                </a>
                <a className="dropdown-item" href="/personnel">
                  <i className="fa fa-archive fa-rotate-90 fa-lg mr-3" aria-hidden="true"></i>
                  Liste Personnel
                </a>

                <a className="dropdown-item" href="/statisticsbyorganique">
                  <i className="fa fa-shield fa-rotate-90 fa-lg mr-3" aria-hidden="true"></i>
                  C. Organique
                </a>

                <a className="dropdown-item" href="/statisticsbyoperationnel">
                  <i className="fa fa-adjust fa-rotate-90 fa-lg mr-3" aria-hidden="true"></i>
                  Effectifs Opérationnels
                </a>

                <a className="dropdown-item" href="/listeboasss">
                  <i className="fa fa-shield fa-rotate-90 fa-lg mr-3" aria-hidden="true"></i>
                  Liste Boa et DSS
                </a>

                <a className="dropdown-item" href="/decoration">
                  <i className="fa fa-id-badge fa-lg mr-3" aria-hidden="true"></i>
                  Décoration
                </a>

                {(authState.user?.roles === 'SUPERADMIN' || authState.user?.roles === 'ADMIN') && (
                  <>
                    <a className="dropdown-item" href="/listusers">
                      <i className="fa fa-amazon fa-lg mr-3" aria-hidden="true"></i>
                      USERS
                    </a>


                    <a className="dropdown-item" href="/etsouservice">
                      <i className="fa fa-id-badge fa-lg mr-3" aria-hidden="true"></i>
                      Ets ou Services
                    </a>
                    <a className="dropdown-item" href="/grade">
                      <i className="fa fa-id-badge fa-lg mr-3" aria-hidden="true"></i>
                      Grade
                    </a>

                    <a className="dropdown-item" href="/listministresuccessifs">
                      <i className="fa fa-id-badge fa-lg mr-3" aria-hidden="true"></i>
                      Ministres successifs
                    </a>
                    <a className="dropdown-item" href="/etatmajoruccessifs">
                      <i className="fa fa-id-badge fa-lg mr-3" aria-hidden="true"></i>
                      Chef d'Etat-Major
                    </a>
                    <a className="dropdown-item" href="/directeurs">
                      <i className="fa fa-id-badge fa-lg mr-3" aria-hidden="true"></i>
                      Directeur de la DCCA
                    </a>
                    <a className="dropdown-item" href="/compagnie">
                      <i className="fa fa-id-badge fa-lg mr-3" aria-hidden="true"></i>
                      Compagnie
                    </a>
                    <a className="dropdown-item" href="/bataillon">
                      <i className="fa fa-id-badge fa-lg mr-3" aria-hidden="true"></i>
                      Bataillon
                    </a>
                    <a className="dropdown-item" href="/brigade">
                      <i className="fa fa-id-badge fa-lg mr-3" aria-hidden="true"></i>
                      Brigade
                    </a>
                    <a className="dropdown-item" href="/zonededefenses">
                      <i className="fa fa-id-badge fa-lg mr-3" aria-hidden="true"></i>
                      Zone de défense
                    </a>
                    <a className="dropdown-item" href="/importpersonnel">
                      <i className="fa fa-id-badge fa-lg mr-3 " aria-hidden="true"></i>
                      Importation personnel
                    </a>


                    <a className="dropdown-item" href="/doublonspersonnels">
                      <i className="fa fa-id-badge fa-lg mr-3 " aria-hidden="true"></i>
                      Liste des doublons
                    </a>
                  </>
                )}



              </div>
            </div>
          </li>
          <li className="nav-item">
            {/* authState.user?.roles === 'USERS' ||  */}
            {authState.user?.roles === 'SUPERADMIN' && (
              <a className="nav-link active" href=" /statistics">
                <i className="fa fa-amazon fa-lg mr-3" aria-hidden="true"></i>
                Statistiques
              </a>
            )}
          </li>
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle active" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Retraité
            </a>
            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
              <div>
                <a className="dropdown-item " href="/personnelsmilitaireretraite">
                  <i className="fa fa-address-card fa-lg mr-3" aria-hidden="true"></i>
                  Personnel Militaire dans 2 ans
                </a>
                <a className="dropdown-item" href="/personnelscivilretraite">
                  <i className="fa fa-archive fa-rotate-90 fa-lg mr-3" aria-hidden="true"></i>
                  Personnel Civil dans 2 ans
                </a>
              </div>
            </div>
          </li>
          {/*           <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle active"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Acanthe
            </a>
            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
              <a
                className="dropdown-item"
                href=" {{path('home.feuilleacanthe')}} "
              >
                <i className="fa fa-sun-o fa-lg mr-3"></i>
                La feuille d ’Acanthe
              </a>
              <a className="dropdown-item" href="{{path('home.actusport')}} ">
                <i className="fa fa-sun-o fa-lg mr-3"></i>
                L’ Actu : Sports
              </a>
              <a className="dropdown-item" href="{{path('home.saintmartin')}} ">
                <i className="fa fa-sun-o fa-lg mr-3"></i>
                Saint Martin : 16 Novembre 2018
              </a>
            </div>
          </li> */}
          <li className="nav-item dropdown">
            <a className="nav-link active" href="/decoration ">
              Honorifique
            </a>
          </li>
          <li className="nav-item dropdown">
            {authState.user?.roles === 'SUPERADMIN' && (
              <a className="nav-link active" href="/cartebrigademadagascar">
                CARTE
              </a>
            )}

          </li>
        </ul>
        {/*         <form class="form-inline my-2 my-lg-0">
          <input className="form-control me-2" type="search" placeholder="Recherche personnel" aria-label="Search" value={nomprenom} onChange={handleChange} />
        </form> */}
        <ul>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i className="fa fa-cog fa-2x"> </i>
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="#">
                {authState.user && authState.user.roles}
              </a>
              <a class="dropdown-item" href="#">
                {authState.user && authState.user.username}
                {authState.user && authState.user.observation}
              </a>
              <div class="dropdown-divider"></div>
              {authState.user ? (
                <button className="dropdown-item text-danger" onClick={logout}>
                  Déconnexion
                </button>
              ) : (
                <div>
                  <Link to="/login">Connecter</Link>
                  <br />
                  {authState.user?.roles == 'SUPERADMIN' && (
                    <a className="dropdown-item" href="/createdusers">
                      <i className="fa fa-amazon fa-lg mr-3" aria-hidden="true"></i>
                      Sign Up
                    </a>
                  )}
                </div>
              )}
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
}
export default Navbar;
